import gql from "graphql-tag";

export default gql`
  fragment EditablePostFields on EditablePost {
    updatedAt
  }
`;
